module.exports = __webpack_public_path__ + "img/logo-ms365.facb227b.png";